import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Typography,
  Paper,
  Grid,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import db from "../../services/db"; // Supondo que db seja o seu IndexedDB

const ListaPrecoList = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [produto, setProduto] = useState("");
  const [promo, setPromo] = useState(false);
  const [produtos, setProdutos] = useState([]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterChange = (e) => {
    setProduto(e.target.value);
  };

  const handleSearch = async () => {
    try {
      const produtoData = await db.produtos.toArray();
      let produtosComPreco = await Promise.all(
        produtoData.map(async (produto) => {
          const precos = await db.precos
            .where("idProdutoPrecificacao")
            .equals(produto.idProdutoPrecificacao)
            .toArray();
          return { ...produto, precos: precos[0] };
        })
      );

      if (produto) {
        produtosComPreco = produtosComPreco.filter((item) =>
          item.descricao.toLowerCase().includes(produto.toLowerCase()) ||
          item.codigoProduto.toString().includes(produto)
        );
      }
      if (promo) {
        produtosComPreco = produtosComPreco.filter((item) => item.precos?.promocao1);
      }

      setProdutos(produtosComPreco);
    } catch (error) {
      console.error("Erro ao filtrar os dados:", error);
    }
  };

  useEffect(() => {
    handleSearch();
  }, [produto, promo]);

  const handleClear = () => {
    setProduto("");
    setPromo(false);
  };

  const fetchData = async () => {
    try {
      const produtoData = await db.produtos.toArray();
      const produtosComPreco = await Promise.all(
        produtoData.map(async (produto) => {
          const precos = await db.precos
            .where("idProdutoPrecificacao")
            .equals(produto.idProdutoPrecificacao)
            .toArray();
          return { ...produto, precos: precos[0] };
        })
      );
      setProdutos(produtosComPreco);
    } catch (error) {
      console.error("Erro ao carregar os dados:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Box p={3}>
      <Typography variant="h6" gutterBottom>
        Lista de Preços
      </Typography>

      {/* Filtros Responsivos */}
      <Box mb={2}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Produto ou Código"
              name="produto"
              variant="outlined"
              size="small"
              value={produto}
              fullWidth
              onChange={handleFilterChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={promo}
                  onChange={(e) => setPromo(e.target.checked)}
                />
              }
              label="Itens em promoção"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Button variant="contained" fullWidth onClick={handleSearch}>
              Localizar
            </Button>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Button
              variant="outlined"
              fullWidth
              startIcon={<ClearIcon />}
              onClick={handleClear}
            >
              Limpar
            </Button>
          </Grid>
        </Grid>
      </Box>

      {/* Tabela Responsiva */}
      <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Código</TableCell>
              <TableCell>Descrição</TableCell>
              <TableCell>UN.</TableCell>
              <TableCell>Disponível</TableCell>
              <TableCell>Preço Varejo</TableCell>
              <TableCell>Preço Atacado</TableCell>
              <TableCell>Promoção</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {produtos
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row.codigoProduto}</TableCell>
                  <TableCell>{row.descricao}</TableCell>
                  <TableCell>{row.unidade}</TableCell>
                  <TableCell>{row.quantidadeDisponivel}</TableCell>
                  <TableCell>{row.precos?.precoVistaVarejo || "N/A"}</TableCell>
                  <TableCell>{row.precos?.precoVistaAtacado || "N/A"}</TableCell>
                  <TableCell>{row.precos?.promocao1 || "N/A"}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={produtos.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </Box>
  );
};

export default ListaPrecoList;
